import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4d65ce08"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  ref: "sidebar",
  class: "sidebar d-flex flex-column"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex-grow-1"
}, null, -1));
const _hoisted_3 = {
  key: 0,
  class: "sidebar-footer-menu"
};
const _hoisted_4 = ["id", "onClick"];
const _hoisted_5 = {
  key: 1,
  class: "profile-settings"
};
const _hoisted_6 = {
  class: "profile"
};
const _hoisted_7 = {
  class: "avatar"
};
const _hoisted_8 = {
  class: "profile-info"
};
const _hoisted_9 = {
  class: "username"
};
const _hoisted_10 = {
  class: "role"
};
const _hoisted_11 = {
  class: "settings"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  class: "setting-btn"
};
const _hoisted_14 = {
  class: "btn-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_top_account = _resolveComponent("top-account");
  const _component_the_sidebar_menu = _resolveComponent("the-sidebar-menu");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_alerts_notification_badge = _resolveComponent("alerts-notification-badge");
  const _component_feature = _resolveComponent("feature");
  const _component_wrap_with_popover = _resolveComponent("wrap-with-popover");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sidebar-wrapper", [{
      hovering: $props.isHovering
    }]]),
    onMouseenter: _cache[3] || (_cache[3] = e => $options.handleMouseEnter(e)),
    onMouseleave: _cache[4] || (_cache[4] = e => $options.handleMouseLeave(e))
  }, [_createVNode(_component_top_account, {
    isCollapsed: $props.isCollapsed,
    isHovering: $props.isHovering,
    showTopAccountListView: $props.showTopAccountListView,
    onListViewToggled: $options.handleListViewToggled
  }, null, 8, ["isCollapsed", "isHovering", "showTopAccountListView", "onListViewToggled"]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(["sidebar-options-container", {
      'hide-click-top-account': $props.showTopAccountListView
    }])
  }, [_createVNode(_component_the_sidebar_menu, {
    isCollapsed: $props.isCollapsed,
    isHovering: $props.isHovering,
    onHandleCollapse: _cache[0] || (_cache[0] = $event => _ctx.$emit('handleCollapse')),
    openItemText: $data.openItemText,
    onMenuClick: $options.onMenuClick
  }, null, 8, ["isCollapsed", "isHovering", "openItemText", "onMenuClick"])], 2), _hoisted_2], 512), _createElementVNode("div", {
    ref: "collapseBtn",
    class: _normalizeClass(["custom-collapse", {
      collapsed: $props.isCollapsed && !$props.isHovering
    }])
  }, [_createElementVNode("div", {
    class: "avatar-wrapper",
    onClick: _cache[1] || (_cache[1] = _withModifiers($event => _ctx.$emit('handleProfileSettingsClick'), ["stop"]))
  }, [_createVNode(_component_app_icon, {
    icon: "avatar-icon"
  }), _createVNode(_component_feature, {
    name: "alertsfeature"
  }, {
    default: _withCtx(() => [$props.isCollapsed && !$props.isHovering ? (_openBlock(), _createBlock(_component_alerts_notification_badge, {
      key: 0,
      urgencyCount: _ctx.urgencyCount,
      class: "alerts-notification-badge"
    }, null, 8, ["urgencyCount"])) : _createCommentVNode("", true)]),
    _: 1
  })]), !$props.isCollapsed || $props.isHovering ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.settingsItems, item => {
    return _openBlock(), _createElementBlock("div", {
      id: item.id,
      class: "icon-container",
      onClick: () => $options.onClick(item)
    }, [item.text === 'Notifications' ? (_openBlock(), _createBlock(_component_feature, {
      key: 0,
      name: $options.getFeatureName(item)
    }, {
      default: _withCtx(() => [_createVNode(_component_app_icon, {
        icon: item.icon
      }, null, 8, ["icon"]), _createVNode(_component_alerts_notification_badge, {
        urgencyCount: _ctx.urgencyCount,
        class: "alerts-notification-badge"
      }, null, 8, ["urgencyCount"])]),
      _: 2
    }, 1032, ["name"])) : (_openBlock(), _createBlock(_component_app_icon, {
      key: 1,
      icon: item.icon
    }, null, 8, ["icon"]))], 8, _hoisted_4);
  }), 256)), _withDirectives(_createElementVNode("div", {
    id: "collapse",
    class: "icon-container",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.handleCollapseClick && $options.handleCollapseClick(...args))
  }, [_createVNode(_component_app_icon, {
    icon: "sidebar-collapse"
  })], 512), [[_vShow, !$options.showSmallLogo]])])) : _createCommentVNode("", true), this.isProfileSettingsShown ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_app_icon, {
    icon: "avatar-icon",
    size: "24"
  })]), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString($options.userName), 1), _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.userRoleGet), 1)])]), _createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.settingsBtn, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "profile-settings-btn",
      onClick: () => $options.onClick(item)
    }, [_createElementVNode("div", _hoisted_13, [_createVNode(_component_app_icon, {
      icon: item.icon
    }, null, 8, ["icon"]), _createElementVNode("span", _hoisted_14, _toDisplayString(item.text), 1)])], 8, _hoisted_12);
  }), 256))])])) : _createCommentVNode("", true)], 2), !$props.isCollapsed ? (_openBlock(), _createBlock(_component_wrap_with_popover, {
    key: 0,
    target: "notification",
    placement: "top",
    width: "fit-content"
  }, {
    title: _withCtx(() => [_createTextVNode("Notifications")]),
    _: 1
  })) : _createCommentVNode("", true), !$props.isCollapsed ? (_openBlock(), _createBlock(_component_wrap_with_popover, {
    key: 1,
    target: "help",
    placement: "top",
    width: "fit-content"
  }, {
    title: _withCtx(() => [_createTextVNode("Help")]),
    _: 1
  })) : _createCommentVNode("", true), !$props.isCollapsed ? (_openBlock(), _createBlock(_component_wrap_with_popover, {
    key: 2,
    target: "collapse",
    placement: "top",
    width: "fit-content"
  }, {
    title: _withCtx(() => [_createTextVNode("Collapse")]),
    _: 1
  })) : _createCommentVNode("", true)], 34);
}